import { Grid, Link } from "@material-ui/core";
import { IconVehicle } from "icons";
import { VehicleLinksStyle } from "./style.js";

export const VehicleLinks = ({ vehicles }) => {
    const classes = VehicleLinksStyle();
    return (<Grid container direction="column" >
        <div className={classes.linkedAssets}>
            {vehicles?.map((asset, index) =>
                <>
                    <Grid item container spacing={1} key={index} className={classes.noMarginBottom}>
                        {asset?.id ? <>
                            <Grid item className={classes.iconWrapper}><IconVehicle /></Grid>
                            <Grid item>
                                <Link target='_blank' href={`/assets/detail/${asset?.id}`} className={classes.link}>{asset?.vin || asset?.assetId || asset?.id}</Link>
                            </Grid>
                        </>
                            : <Grid item>{asset?.vin || asset?.assetId || asset?.id}</Grid>}
                    </Grid ></>)}
        </div>
    </Grid>
    )
}